import { render, staticRenderFns } from "./OfferedProduct.vue?vue&type=template&id=4abbb5a6&"
import script from "./OfferedProduct.vue?vue&type=script&lang=js&"
export * from "./OfferedProduct.vue?vue&type=script&lang=js&"
import style0 from "./OfferedProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports